
interface PromoCarouselProps {
    imageWidth: number
    marginRight: number
    itemListLength: number
    currentPromoIndex?: number
    onUserArrowInteraction?: () => void
    pushGA4Event?: (action: string, isFeedDisplay: boolean) => void
}

interface PromoCarouselState {
    isCarouselMoving: boolean
    touchStartX: number | null
    isLeftArrowVisible: boolean
    isRightArrowVisible: boolean
}

export class PromoCarousel extends React.Component<PromoCarouselProps, PromoCarouselState>{

    constructor(props) {
        super(props);
        this.state = {
            touchStartX: null,
            isCarouselMoving: false,
            isLeftArrowVisible: false,
            isRightArrowVisible: false,
        }
    }

    private slotWrapperRef: HTMLDivElement | null = null;
    private scrollAnimationFrame: number | null = null;

    componentDidMount() {
        this.slotWrapperRef.addEventListener('scroll', this.handleScroll);
        this.slotWrapperRef.addEventListener('wheel', this.handleScroll);
        this.handleScroll()
    }

    componentWillUnmount() {
        this.slotWrapperRef.removeEventListener('scroll', this.handleScroll);
        this.slotWrapperRef.removeEventListener('wheel', this.handleScroll);
        if (this.scrollAnimationFrame !== null) {
            cancelAnimationFrame(this.scrollAnimationFrame);
        }
    }

    private animateScrollBy = (scrollAmount: number, duration: number = 350) => {
        const el = this.slotWrapperRef;
        if (!el) {
            return;
        }

        if (this.scrollAnimationFrame !== null) {
            cancelAnimationFrame(this.scrollAnimationFrame);
        }

        const startLeft = el.scrollLeft;
        const targetLeft = startLeft + scrollAmount;
        const startTime = performance.now();

        const step = (now: number) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            el.scrollLeft = startLeft + (targetLeft - startLeft) * eased;

            if (progress < 1) {
                this.scrollAnimationFrame = requestAnimationFrame(step);
            } else {
                this.scrollAnimationFrame = null;
            }
        };

        this.scrollAnimationFrame = requestAnimationFrame(step);
    }

    private handleScroll = () => {
        const newScrollLeft = this.slotWrapperRef.scrollLeft;
        const isRightArrowVisible = newScrollLeft < 0;
        const isLeftArrowVisible = Math.abs(newScrollLeft) + this.slotWrapperRef.clientWidth < this.slotWrapperRef.scrollWidth;
        this.setState({ isRightArrowVisible, isLeftArrowVisible });
    }

    private onTouchStart = (e) => {
        this.setState({ isCarouselMoving: true, touchStartX: e.touches[0].clientX });
    }

    private onTouchEnd = (e) => {
        const { pushGA4Event, currentPromoIndex, itemListLength, onUserArrowInteraction } = this.props;
        const { touchStartX } = this.state;

        setTimeout(() => {
            this.setState({ isCarouselMoving: false });
        }, 1000);

        if (touchStartX !== null && e.changedTouches.length > 0) {
            const touchEndX = e.changedTouches[0].clientX;
            const deltaX = touchEndX - touchStartX;

            if (Math.abs(deltaX) > 30) {
                onUserArrowInteraction && onUserArrowInteraction();
            }

            const shouldPushEventRight = deltaX < 0 && currentPromoIndex > 0;
            const shouldPushEventleft = deltaX > 0 && currentPromoIndex < itemListLength - 1;

            shouldPushEventRight ? pushGA4Event && pushGA4Event(`swipe_right`, false) : shouldPushEventleft && pushGA4Event && pushGA4Event(`swipe_left`, false);
        }
    }

    private handleScrollLeftClicked = () => {
        const { imageWidth, marginRight, pushGA4Event, onUserArrowInteraction } = this.props;

        onUserArrowInteraction && onUserArrowInteraction();
        this.animateScrollBy(-(imageWidth + marginRight));
        pushGA4Event && pushGA4Event("swipe_left", false);
    };

    private handleScrollRightClicked = () => {
        const { imageWidth, marginRight, pushGA4Event, onUserArrowInteraction } = this.props;

        onUserArrowInteraction && onUserArrowInteraction();
        this.animateScrollBy(imageWidth + marginRight);
        pushGA4Event && pushGA4Event("swipe_right", false);
    };

    public render() {
        const { isRightArrowVisible, isLeftArrowVisible } = this.state;

        return (
            <div className="slotsContent">
                <button
                    aria-label="scroll right"
                    className="scrollRight arrowBtn"
                    disabled={!isRightArrowVisible}
                    onClick={this.handleScrollRightClicked}
                />

                <div className="frame_forList">
                    <div
                        className="slotListWrapper"
                        onTouchEnd={this.onTouchEnd}
                        onTouchStart={this.onTouchStart}
                        ref={ref => (this.slotWrapperRef = ref)}
                    >
                        {this.props.children}
                    </div>
                </div>

                <button
                    aria-label="scroll left"
                    className="scrollLeft arrowBtn"
                    disabled={!isLeftArrowVisible}
                    onClick={this.handleScrollLeftClicked}
                />
            </div>
        )
    }
}

